module.exports = __webpack_public_path__ + "856fef111bb1b1229fde8b1177b7d98b.woff2";